import React, { useContext, useEffect, useState } from "react";
import { BASE_URL_API } from "../../References/URLs";
import AuthContext from "../../Store/AuthContext";
import { motion } from "framer-motion";
import { CheckCircle, XCircle, Clock, Search, Filter } from "lucide-react";
import styles from "./OrderHistory.module.css";
import { humanReadableTimePassed } from "../../Helper/calculations";
import { Link } from "react-router";

const OrderHistory = () => {
    const authCtx = useContext(AuthContext);
    const loginData = JSON.parse(authCtx.loginData);
    const [orderHistory, setOrderHistory] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filterStatus, setFilterStatus] = useState("All");
    const [filterPointsUsed, setFilterPointsUsed] = useState("All");

    const getOrderHistory = async () => {
        try {
            const response = await fetch(BASE_URL_API + "getOrderHistory", {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: loginData?.userIdentifier,
                }),
            });

            const result = await response.json();
            if (result.status === "success") {
                setOrderHistory(result.response);
            } else {
                if (result.message === "token Expired, please login again!") {
                    authCtx.logout();
                }
            }
        } catch (error) {
            console.error("Error fetching order history:", error);
        }
    };

    useEffect(() => {
        getOrderHistory();
    }, []);

    const statusIcons = {
        ORDER_PLACED: <Clock className={styles.statusIconPlaced} />,
        DELIVERED: <CheckCircle className={styles.statusIconDelivered} />,
        CANCELLED: <XCircle className={styles.statusIconCancelled} />,
    };

    const filteredOrders = orderHistory.filter(order =>
        (filterStatus === "All" || order.currentStatus === filterStatus) &&
        (filterPointsUsed === "All" || order.pointsUsed === filterPointsUsed) &&
        (order?.itemTitle?.toLowerCase().includes(searchQuery?.toLowerCase()) ||
            order.orderIdentifier.includes(searchQuery))
    );

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.05,
                duration: 0.3,
                type: 'spring',
            },
        }),
    };


    return (
        <div className={styles.mainWrapper}>
            <div className={styles.container}>
                <div className={styles.mainHeader}>
                    <motion.div
                        className={styles.heading}
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        Order History
                    </motion.div>

                    <div className={styles.filtersWrapper}>
                        <div className={styles.countWrapper}>
                            Showing {filteredOrders?.length} results out of {orderHistory?.length} total orders.
                        </div>
                        <div className={styles.searchBar}>
                            <Search className={styles.searchIcon} />
                            <input
                                type="text"
                                placeholder="Search by order ID or item name..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <div className={styles.filterControls}>
                            <Filter className={styles.filterIcon} />
                            <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                                <option value="All">All Status</option>
                                <option value="ORDER_PLACED">Order Placed</option>
                                <option value="DELIVERED">Delivered</option>
                                <option value="CANCELLED">Cancelled</option>
                            </select>
                            <select value={filterPointsUsed} onChange={(e) => setFilterPointsUsed(e.target.value)}>
                                <option value="All">All Points Used</option>
                                <option value="0">No Points Used</option>
                                <option value="5000">5000 Points Used</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div className={styles.mainBody}>
                    {filteredOrders.length > 0 ? (
                        <motion.div
                            className={styles.orderList}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.2 }}
                        >
                            {/* {filteredOrders.map((order) => (
                                <motion.div
                                    key={order.ID}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <div className={styles.orderCard}>
                                        <div className={styles.cardContent}>
                                            <div className={styles.orderTopRow}>
                                                <div className={styles.orderId}>Order ID: {order.orderIdentifier}</div>
                                                <div className={styles.statusContainer}>
                                                    {statusIcons[order.currentStatus]}
                                                    <span className={styles.orderStatus}>{order.currentStatus}</span>
                                                </div>
                                            </div>
                                            <div className={styles.orderTitle}>{order.itemTitle}</div>
                                            <div className={styles.orderInfo}>Placed on: {order.placedOn}</div>
                                            <div className={styles.orderInfo}>Receiver: {order.receiverPerson} ({order.receiverPhone})</div>
                                            <div className={styles.orderInfo}>Address: {order.deliveryAddress}</div>
                                            <div className={styles.orderInfo}>Points Used: {order.pointsUsed}</div>
                                        </div>
                                    </div>
                                </motion.div>
                            ))} */}

                            <div className={styles.tableWrapper}>
                                <div className={styles.rowsWrapper}>
                                    {filteredOrders?.map((item, index) => (
                                        <motion.div className={styles.eachRowWrapper} key={index}
                                            variants={itemVariants}
                                            initial="hidden"
                                            animate="visible"
                                            custom={index}
                                        >
                                            <div className={styles.firstRowWrapper}>
                                                <div className={styles.leftCol}>
                                                    <div className={styles.thumbnailWrapper}>
                                                        {item?.items?.slice(0, 3)?.map((itemItems, indexItems) => (
                                                            <div
                                                                className={styles.thumbnail}
                                                                key={indexItems}
                                                                style={{
                                                                    left: `${indexItems * 10}px`,
                                                                    top: `${indexItems * 10}px`,
                                                                    zIndex: item?.items?.length - indexItems
                                                                }}
                                                            >
                                                                <img
                                                                    src={
                                                                        itemItems?.productThumbnail ||
                                                                        "https://t4.ftcdn.net/jpg/12/00/79/01/360_F_1200790111_37LoouDliNEWTX3ivRhB1IqJFvjl4PqR.jpg"
                                                                    }
                                                                />
                                                            </div>
                                                        ))}

                                                    </div>
                                                </div>
                                                <div className={styles.centerCol}>
                                                    <div className={styles.sn}>
                                                        # {item?.orderIdentifier}
                                                    </div>
                                                    <div className={styles.receiverDetails}>
                                                        <div className={styles.fullname}>
                                                            {item?.receiverPerson}, {item?.receiverPhone}
                                                        </div>
                                                        <div className={styles.address}>
                                                            <div className={styles.fullAddress}>
                                                                {item?.deliveryAddress}
                                                            </div>
                                                        </div>
                                                        <div className={styles.address}>
                                                            {item?.items?.length} item(s)!
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className={styles.points}>
                                                        {item?.isPointsBasedTransaction === "0" ?
                                                            <span>
                                                                ₹{item?.totalAmount}
                                                            </span>
                                                            :
                                                            <div>
                                                                <div className={styles.totalPoints}>
                                                                    {parseInt(item?.totalPoints)}
                                                                </div>
                                                                <div className={styles.puTxt}>Points used</div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className={styles.rightCol}>
                                                    <div className={styles.currentStatus}>
                                                        {item?.currentStatus}
                                                    </div>
                                                    <div className={styles.dateTime}>
                                                        {humanReadableTimePassed(item?.placedOn)}
                                                    </div>
                                                    <div className={styles.dateTime}>
                                                        <div className={styles.placedOn}>
                                                            {item?.placedOn}
                                                        </div>
                                                    </div>
                                                    <div className={styles.time}>
                                                        <Link to={`/points/order/${item?.orderIdentifier}`}>View Details</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={styles.secondRowWrapper}>
                                                <div>

                                                </div>
                                            </div>

                                        </motion.div>
                                    ))}
                                </div>
                            </div>
                            <div className={styles.thatsAll}>
                                That's all!
                            </div>
                        </motion.div>
                    ) : (
                        <motion.p
                            className={styles.noOrders}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            No orders found.
                        </motion.p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrderHistory;